import { Alert } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Card, CardBody } from 'reactstrap';
import { AccordionElement } from 'src/component/Accordion';
import { ActivityAccordion } from 'src/component/ActivityAccordion';
import ProjectForm from 'src/component/ProjectForm';
import ProjectWrapper from 'src/component/ProjectWrapper';
import { useProject } from 'src/hooks/useProject';
import { useHttpClient } from '../../../../security/hooks/axiosProvider';

import NestedAccordion from 'src/component/LocalityAccordion';
import TechnicianColumns from './table-header/technicien-columns';

const DetailProjectPage = (props) => {
  const [currentCountry, setCurrentCountry] = useState(null);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedDepartements, setSelectedDepartements] = useState([]);
  const [selectedCommunes, setSelectedCommunes] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState([]);

  const httpClient = useHttpClient(true);
  const params = useParams();

  const { register, setValue } = useForm();
  const [workshops, setWorkshops] = useState([]);
  const [techniciens, setTechniciens] = useState([]);

  const [admin, setAdmin] = useState([]);

  const [spinner, setSpinner] = useState(false);
  let technicienData = [];
  let workshopData = [];
  let adminData = [];

  workshops.map((workshop) => {
    workshopData.push({
      name: workshop.name,
    });
    return workshopData;
  });

  techniciens.map((projectTechnicien) => {
    technicienData.push({
      name: projectTechnicien.username,
      nom: projectTechnicien.nom,
      prenom: projectTechnicien.prenom,
      email: projectTechnicien.email,
    });
    return technicienData;
  });
  admin.map((admin) => {
    adminData.push({
      id: admin.id,
      username: admin.username,
      nom: admin.nom,
      prenom: admin.prenom,
      email: admin.email,
    });
    return adminData;
  });

  useEffect(() => {
    const getProjectById = async () => {
      setSpinner(true);
      httpClient.current
        ?.get(`/api/project/${params['id']}`)
        .then((response) => {
          console.log(response.data);
          const { name, startDate, endDate, description, activityList, userList, administrator } = response.data;
          setValue('project_name', name);
          setValue('project_start_date', startDate);
          setValue('project_end_date', endDate);
          setValue('project_description', description);
          setWorkshops(activityList);
          setTechniciens(userList);
          setCurrentCountry(response.data.country);
          setSelectedRegions(response.data.country.regionList || []);
          setSelectedDepartements(response.data.country.regionList?.map((item) => item.departementList).flat() || []);
          setSelectedCommunes(
            response.data.country.regionList
              ?.map((item) => item.departementList)
              .flat()
              .map((item) => item.communeList)
              .flat() || []
          );
          setSelectedVillages(
            response.data.country.regionList
              ?.map((item) => item.departementList)
              .flat()
              .map((item) => item.communeList)
              .flat()
              .map((item) => item.villageList)
              .flat() || []
          );
          setAdmin([administrator]);
          setSpinner(false);
        })
        .catch((error) => {
          setSpinner(false);
        });
    };

    getProjectById();
  }, [params, httpClient, setValue]);

  const { project: project$ } = useProject();

  const [selctedAdminForProject, setSelctedAdminForProject] = useState(null);

  const [currentDevise, setCurrentDevise] = useState(null);

  useEffect(() => {
    if (project$) {
      setSelctedAdminForProject(project$.administrator);
      setCurrentDevise(project$?.devise || null);
    }
  }, [project$]);
  console.log(project$?.activityList);

  return (
    <ProjectWrapper title="Details_Project" spinner={spinner}>
      {project$ ? (
        <ProjectForm
          selctedAdminForProject={selctedAdminForProject}
          currentDevise={currentDevise}
          currentCountry={currentCountry}
          register={register}
          action="preview"
          isDisabled={true}
        >
          <div style={{ marginBottom: '20px' }}>
            <AccordionElement title={props.t('technicians')}>
              <div className=" col d-flex justify-content-center">
                <Card className="col-md-12">
                  <CardBody>
                    {technicienData.length === 0 ? (
                      <Alert variant="outlined" severity="info">
                        {props.t('no_technician')}
                      </Alert>
                    ) : (
                      <TechnicianColumns data={technicienData} />
                    )}
                  </CardBody>
                </Card>
              </div>
            </AccordionElement>

            {workshopData.length === 0 ? (
              <AccordionElement title={props.t('activities')}>
                <Alert variant="outlined" severity="info">
                  {props.t('no_activity')}
                </Alert>
              </AccordionElement>
            ) : (
              <ActivityAccordion t={props.t} collection={project$?.activityList} />
            )}

            {/* locality */}
            <AccordionElement title={props.t('localities$')}>
              <NestedAccordion
                country={currentCountry ? currentCountry : null}
                t={props.t}
                regions={currentCountry?.regionList}
                handleAddVillage={() => {}}
                handleDeleteVillage={() => {}}
                setModalSelectRegions={() => {}}
                setModalSelectDepartements={() => {}}
                setModalSelectCommunes={() => {}}
                setSelectedRegion={() => {}}
                setSelectedDepartement={() => {}}
                setSelectedCommune={() => {}}
                onDelete={() => {}}
                isPreview={true}
              />
            </AccordionElement>
            {/* locality */}
          </div>
        </ProjectForm>
      ) : (
        <Alert variant="outlined" severity="info">
          {props.t('no_project')}
        </Alert>
      )}
    </ProjectWrapper>
  );
};

export default translate(DetailProjectPage);
